import { ClickAwayListener } from '@mui/base'
import Popper from '@mui/material/Popper'
import { arrayOf, bool, element, func, object, oneOfType, instanceOf } from 'prop-types'
import { Paper } from '@components'

export const PickerBase = ({
  anchorEl = null,
  children = null,
  onClose,
  open = false,
  style = {},
  ...otherProps
}) => {
  return (
    <ClickAwayListener onClickAway={onClose}>
      <Popper
        anchorEl={anchorEl}
        onClose={onClose}
        open={open}
        placement="bottom-start"
        style={{
          ...style,
          /* When adding Fields or Patterns to a template, this component needs to be 
        positioned in front of the Floating Action Buttons, which have a z-index of 1050 */
          zIndex: 1051,
        }}
        {...otherProps}
      >
        <Paper
          elevation={5}
          style={{
            width: 500,
            height: 500,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            overflow: 'hidden',
          }}
        >
          {children}
        </Paper>
      </Popper>
    </ClickAwayListener>
  )
}

PickerBase.propTypes = {
  anchorEl: instanceOf(Element),
  onClose: func.isRequired,
  children: oneOfType([element, arrayOf(element)]),
  open: bool,
  style: object,
}
